var _path, _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBokamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 114C88.4802 114 114 88.4802 114 57C114 25.5198 88.4802 0 57 0C25.5198 0 0 25.5198 0 57C0 88.4802 25.5198 114 57 114Z",
    fill: "white",
    fillOpacity: 0.01
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 114,
    height: 114
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 114C88.4802 114 114 88.4802 114 57C114 25.5198 88.4802 0 57 0C25.5198 0 0 25.5198 0 57C0 88.4802 25.5198 114 57 114Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6442 90.7572C74.0816 90.7572 86.5961 75.6436 86.5961 57C86.5961 38.3563 74.0816 23.2427 58.6442 23.2427C43.2068 23.2427 30.6923 38.3563 30.6923 57C30.6923 75.6436 43.2068 90.7572 58.6442 90.7572Z",
    fill: "#1B1C1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9231 -18.1374L71.25 23.6661L22.0052 58.6602L21.9231 -18.1374L54.2466 -24.3495L21.9231 -18.1374L44.6813 7.69294L21.9231 -18.1374L44.6813 7.69294",
    fill: "#91278F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9231 -18.1374L71.25 23.6661L22.0052 58.6602L21.9231 -18.1374L54.2466 -24.3495L21.9231 -18.1374L44.6813 7.69294L21.9231 -18.1374L44.6813 7.69294",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.75 -0.659496L70.1774 29.8834L81.1154 -1.89325L48.3433 -3.32043",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.75 -0.659496L70.1774 29.8834L81.1154 -1.89325L48.3433 -3.32043",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3348 -4.98928L73.5194 38.9756L128.67 15.2056L112.469 -9.99377L64.3348 -4.98928Z",
    fill: "#EE4036"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3348 -4.98928L73.5194 38.9756L128.67 15.2056L112.469 -9.99377L64.3348 -4.98928Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8269 33.5217L120.577 21.0291L112.354 52.0194",
    fill: "#F05A29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8269 33.5217L120.577 21.0291L112.354 52.0194",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9231 32.097L132.635 51.0046L78.9231 54.233",
    fill: "#F6931D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9231 32.097L132.635 51.0046L78.9231 54.233",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8269 55.436L120.577 47.5922L119.005 78.5825",
    fill: "#FAAF3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8269 55.436L120.577 47.5922L119.005 78.5825",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7308 56.4466L132.635 71.9248L111.402 125.068L76.7308 56.4466Z",
    fill: "#F8EC31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7308 56.4466L132.635 71.9248L111.402 125.068L76.7308 56.4466Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3932 60.8738L110.712 107.399L67.9615 111.786",
    fill: "#D6DE23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3932 60.8738L110.712 107.399L67.9615 111.786",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1154 65.301L75.1258 116.214L62.4808 76.9288L81.1154 65.301Z",
    fill: "#8CC53F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1154 65.301L75.1258 116.214L62.4808 76.9288L81.1154 65.301Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7308 121.343L66.807 76.3689L42.75 121.748",
    fill: "#39B449"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7308 121.343L66.807 76.3689L42.75 121.748",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8134 130.918L63.345 82.9482H39.5906L43.8134 130.918Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8134 130.918L63.345 82.9482H39.5906L43.8134 130.918Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3454 71.9418L-7.67307 100.099L48.2308 129.495",
    fill: "#006738"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3454 71.9418L-7.67307 100.099L48.2308 129.495",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5577 71.9418L0 96.2913L0.0809535 72.5699",
    fill: "#2BB573"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4615 75.2621H-5.48077V44.2719L39.4615 75.2621Z",
    fill: "#00A69C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4615 75.2621H-5.48077V44.2719L39.4615 75.2621Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-14.25 43.165L39.4615 76.3689L36.8088 43.165",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-13.1538 45.3786L40.5577 43.5254L-4.20192 18.8155L-13.1538 45.3786Z",
    fill: "#1B75BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-13.1538 45.3786L40.5577 43.5254L-4.20192 18.8155L-13.1538 45.3786Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.86539 18.8155L40.5577 45.3786L37.9389 23.5589L-9.86539 18.8155Z",
    fill: "#2A388F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.86539 18.8155L40.5577 45.3786L37.9389 23.5589L-9.86539 18.8155Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4615 24.3495L-12.0577 19.0614L-4.75089 -8.85437L39.4615 24.3495Z",
    fill: "#262261"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4615 24.3495L-12.0577 19.0614L-4.75089 -8.85437L39.4615 24.3495Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.48077 -8.65913L38.3654 24.3495L35.4973 -11.068L-5.48077 -8.65913Z",
    fill: "#662C90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.48077 -8.65913L38.3654 24.3495L35.4973 -11.068L-5.48077 -8.65913Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8852 39.1181C47.9137 34.2219 51.5359 30.5413 55.7517 28.0763C59.9676 25.6112 63.8306 24.3787 67.341 24.3787C72.2968 24.3787 76.7449 26.4867 80.6854 30.7028C84.6259 34.919 86.5962 41.3111 86.5962 49.8793C86.5962 56.6456 85.2884 62.6892 82.6729 68.0103C80.0573 73.3315 76.5556 77.5306 72.1677 80.6077C67.7798 83.6848 62.368 85.2233 55.9324 85.2233C54.074 85.2233 51.252 85.0363 47.4663 84.6623C46.8813 84.5943 46.0209 84.5093 44.8852 84.4073H35.0769V0H44.8852V39.1181ZM44.9423 50.1453V75.0501C48.4831 75.9293 51.7344 76.3689 54.6964 76.3689C60.5864 76.3689 65.5485 74.078 69.583 69.496C73.6174 64.914 75.6346 58.6329 75.6346 50.6525C75.6346 44.8701 74.5366 40.5164 72.3407 37.5914C70.1447 34.6664 67.6509 33.2039 64.8591 33.2039C61.829 33.2039 58.484 34.734 54.8241 37.7943C51.1641 40.8546 47.8702 44.9715 44.9423 50.1453Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 47.0659,
    y1: 32.254,
    x2: 65.9673,
    y2: 28.9806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E0054",
    stopOpacity: 0.802162
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#710043",
    stopOpacity: 0.740218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 57.5525,
    y1: 18.4322,
    x2: 68.9958,
    y2: 13.5542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB008B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 62.0819,
    y1: 26.8898,
    x2: 79.8908,
    y2: 42.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 86.011,
    y1: 30.4292,
    x2: 88.9736,
    y2: 42.3801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 80.0457,
    y1: 38.7373,
    x2: 80.3925,
    y2: 53.2498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79E28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 85.6289,
    y1: 47.5922,
    x2: 85.6289,
    y2: 67.2709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B93D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 93.8609,
    y1: 54.674,
    x2: 79.7507,
    y2: 65.4574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4EB30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 75.1489,
    y1: 107.366,
    x2: 98.0589,
    y2: 98.2644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 70.227,
    y1: 110.391,
    x2: 81.6429,
    y2: 110.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6DE23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 59.3992,
    y1: 116.98,
    x2: 76.7628,
    y2: 113.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BAC4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 44.7747,
    y1: 113.857,
    x2: 57.8535,
    y2: 114.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05974A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39B449"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 18.5364,
    y1: 95.8525,
    x2: 40.1105,
    y2: 99.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 25.9397,
    y1: 75.8041,
    x2: 26.6901,
    y2: 63.4122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D8FAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: -3.15967,
    y1: 40.1561,
    x2: -10.6324,
    y2: 70.1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A72B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AE7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 7.78614,
    y1: 32.0077,
    x2: 6.2976,
    y2: 47.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F63AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1978B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 13.1791,
    y1: 21.7599,
    x2: 12.2342,
    y2: 33.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#522C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F63AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 23.602,
    y1: 15.614,
    x2: 21.8439,
    y2: 21.8552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502E87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 32.1379,
    y1: 4.44699,
    x2: 28.4764,
    y2: 18.6636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2C8B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBokamera);
export default __webpack_public_path__ + "static/media/bokamera.5aced4ec65860a938007e4550d6744bc.svg";
export { ForwardRef as ReactComponent };